export default __webpack_public_path__ + "assets/aa3137fe81f75fe99243bd7e42d959b6.jpeg";